/**
 * WordPress dependencies
 */
import { InnerBlocks } from '@wordpress/block-editor';

export default function CommentTemplateSave() {
	return <InnerBlocks.Content />;
}
